import { SimpleTable } from '@core/components/Table';
import { TableActionButton, TableActionButtonDelete, TableActionButtonEdit } from '@core/components/TableAction';
import TableActionContainer from '@core/components/TableAction/TableActionContainer';
import { permissaoUtils } from '@core/util/permissaoUtil';
import React, { useContext } from 'react';
import { FaToggleOff, FaToggleOn } from 'react-icons/fa';
import { ServicoContext } from '../../ServicoContext';
import ServicoFab from '../ServicoFab';
import { servicoModais } from '../modal/servicoModais';
import { servicoStyles } from './styles';

const getCurrency = (value) =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value).replace('R$', '');

const ServicoTable = ({ onSelection, fetchServicos, fetchServico, onInativar, onAtivar, onDelete, onTour }) => {
  const [servicos] = useContext(ServicoContext).servicos;
  const [selecao] = useContext(ServicoContext).selecao;
  const [loading] = useContext(ServicoContext).loading;
  const [, setModal] = useContext(ServicoContext).modal;
  const [page, setPage] = useContext(ServicoContext).page;
  const [size, setSize] = useContext(ServicoContext).size;
  const [totalElements] = useContext(ServicoContext).totalElements;
  const [search] = useContext(ServicoContext).search;
  const [tipoSelecao, setTipoSelecao] = useContext(ServicoContext).tipoSelecao;
  const [filtroAvancado] = useContext(ServicoContext).filtroAvancado;

  const handleOpenModalVisualizar = async (servico) => {
    await fetchServico(servico.id);
    setModal(servicoModais.visualizarServicoModal);
  };

  const handleOpenModalEditar = async (servico) => {
    await fetchServico(servico.id);
    setModal(servicoModais.editarServicoModal);
  };

  const styles = servicoStyles();

  const handleInativar = (servico) => {
    onInativar([servico], { q: search, page, size });
  };

  const handleAtivar = (servico) => {
    onAtivar([servico], { q: search, page, size });
  };

  const servicoColumnDefs = [
    {
      title: 'Nome do serviço prestado',
      name: 'descricao',
      getCellValue: (servico) => {
        return (
          <div className={styles.descricaoContainer}>
            <span className={styles.descricao}>{servico.descricao}</span>
            {servico.dataInativo ? <div className={styles.badgeInativo}>Inativo</div> : ''}
          </div>
        );
      },
      sortingEnabled: true,
    },
    {
      title: 'Código de identificação',
      name: 'codigo',
      sortingEnabled: true,
    },
    {
      title: 'Valor de custo (R$)',
      name: 'valorCusto',
      getCellValue: (servico) => {
        return servico?.valorCusto ? getCurrency(servico.valorCusto) : '-';
      },
      align: 'right',
      hideTooltip: true,
      sortingEnabled: true,
    },
    {
      title: 'Valor de venda (R$)',
      name: 'valorVenda',
      getCellValue: (servico) => {
        return servico?.valorVenda ? getCurrency(servico.valorVenda) : '-';
      },
      align: 'right',
      hideTooltip: true,
      sortingEnabled: true,
    },
    {
      name: '',
      title: '',
      sortingEnabled: false,
      align: 'left',
      width: 125,
      getCellValue: (servico) => (
        <>
          <TableActionContainer onTour={onTour}>
            {permissaoUtils.servico().editar && (
              <TableActionButtonEdit
                onClick={() => {
                  handleOpenModalEditar(servico);
                }}
                className={'stepIconeEditar'}
              />
            )}
            {permissaoUtils.servico().excluir && (
              <TableActionButtonDelete onClick={() => onDelete([servico.id])} className={'stepIconeExcluir'} />
            )}
            {permissaoUtils.servico().editar && servico.dataInativo && (
              <TableActionButton
                icon={<FaToggleOn size={18} className={'stepIconeAtivar'} />}
                title="Ativar"
                onClick={() => handleAtivar(servico)}
                style={styles.buttonOnOff}
              />
            )}
            {permissaoUtils.servico().editar && !servico.dataInativo && (
              <TableActionButton
                icon={<FaToggleOff size={18} className={'stepIconeAtivar'} />}
                title="Inativar"
                onClick={() => handleInativar(servico)}
                style={styles.buttonOnOff}
              />
            )}
          </TableActionContainer>
        </>
      ),
    },
  ];

  return (
    <>
      <SimpleTable
        getRowId={(row) => row}
        columns={servicoColumnDefs}
        rows={servicos}
        fetchData={fetchServicos}
        loading={loading}
        onRowClick={handleOpenModalVisualizar}
        defaultSorting={[{ columnName: 'descricao', direction: 'asc' }]}
        totalCount={totalElements}
        onCurrentPageChange={(params) => {
          setPage(params);
        }}
        onPageSizeChange={(params) => {
          setSize(params);
        }}
        selectionType={tipoSelecao}
        onSelectionTypeChange={(params) => {
          setTipoSelecao(params);
        }}
        // fetchOnCreate
        selection={selecao}
        onSelectionChange={onSelection}
        onSortingChange={(params) => console.log(params)}
        onLoadingChange={(params) => console.log('loading change', params)}
        searchBy={search}
        params={filtroAvancado}
        contemFiltroAvancado
      />
      {(permissaoUtils.servico().cadastrar || permissaoUtils.servico().excluir) && (
        <ServicoFab selected={selecao.length} onDelete={onDelete} fetchServico={fetchServico} />
      )}
    </>
  );
};

export default ServicoTable;
